module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Cergue-coat_of_arms-532f6d102b01b113d2ee87350b858f63.svg";